// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var ReactIO = require("../../../shared/src/ReactIO.bs.js");
var Reselect = require("../../../shared/src/bindings/Reselect.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var CommonTypes = require("../../../shared/src/types/CommonTypes.bs.js");
var StringUtils = require("../../../shared/src/StringUtils.bs.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_User_Name = require("../../../shared/src/types/CommonTypes_User_Name.bs.js");
var CommonTypes_Worker_Id = require("../../../shared/src/types/worker/CommonTypes_Worker_Id.bs.js");
var BrowserComponents_Icon = require("../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Input = require("../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexRow = require("../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_KebabMenu = require("../../../shared-browser/src/components/BrowserComponents_KebabMenu.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var BrowserComponents_ProfilePicture = require("../../../shared-browser/src/components/BrowserComponents_ProfilePicture.bs.js");

var container = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.minHeight(BrowserStyle.zero),
              tl: {
                hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.medium),
                tl: {
                  hd: BrowserStyle.paddingLeft(BrowserStyle.zero),
                  tl: {
                    hd: BrowserStyle.paddingRight(BrowserStyle.zero),
                    tl: {
                      hd: BrowserStyle.paddingTop(BrowserStyle.zero),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }),
        tl: {
          hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.large),
          tl: {
            hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.xxLarge),
            tl: {
              hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.large),
              tl: {
                hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.large),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var content = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: {
        hd: BrowserStyle.overflowY(BrowserStyle.scroll),
        tl: /* [] */0
      }
    });

var titleRow = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
      tl: /* [] */0
    });

function arg(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* XXLarge */6, /* Bold */2);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), /* [] */0));

var searchInput = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.mobileMedia({
            hd: BrowserStyle.margin3(BrowserStyle.Spacing.medium, BrowserStyle.Spacing.medium, BrowserStyle.Spacing.small),
            tl: {
              hd: BrowserStyle.width(BrowserStyle.unset),
              tl: /* [] */0
            }
          }),
      tl: {
        hd: BrowserStyle.width(BrowserStyle.rem(15.0)),
        tl: /* [] */0
      }
    });

var buttonContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.justifyContent(BrowserStyle.flexEnd),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.medium),
              tl: {
                hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.medium),
                tl: /* [] */0
              }
            }),
        tl: /* [] */0
      }
    });

function headerRow(isKebabMenuVisible) {
  var arg = function (param, param$1) {
    return BrowserStyle.withFont(param, param$1, /* Small */2, /* Semibold */1);
  };
  return Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
                  hd: BrowserStyle.alignItems(BrowserStyle.center),
                  tl: {
                    hd: BrowserStyle.borderBottom(BrowserStyle.rem(0.0125), BrowserStyle.solid, {
                          TAG: /* Grey */2,
                          _0: /* Lightest */4
                        }),
                    tl: {
                      hd: BrowserStyle.color({
                            TAG: /* Grey */2,
                            _0: /* Medium */2
                          }),
                      tl: {
                        hd: BrowserStyle.mobileMedia({
                              hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.medium),
                              tl: {
                                hd: BrowserStyle.paddingRight(isKebabMenuVisible ? BrowserStyle.rem(3.25) : BrowserStyle.zero),
                                tl: {
                                  hd: BrowserStyle.paddingTop(BrowserStyle.Spacing.small),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        tl: {
                          hd: BrowserStyle.paddingBottom(BrowserStyle.Spacing.small),
                          tl: {
                            hd: BrowserStyle.paddingRight(isKebabMenuVisible ? BrowserStyle.rem(2.25) : BrowserStyle.zero),
                            tl: /* [] */0
                          }
                        }
                      }
                    }
                  }
                }));
}

var headerNameRow = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: /* [] */0
    });

var headerFlexPusher = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: /* [] */0
    });

var workerRow = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.borderBottom(BrowserStyle.rem(0.0125), BrowserStyle.solid, {
              TAG: /* Grey */2,
              _0: /* Lightest */4
            }),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.medium),
                tl: {
                  hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.small),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: BrowserStyle.padding2(BrowserStyle.Spacing.medium, BrowserStyle.zero),
            tl: /* [] */0
          }
        }
      }
    });

var workerNameRow = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.flex({
              NAME: "num",
              VAL: 1.0
            }),
        tl: {
          hd: BrowserStyle.minWidth(BrowserStyle.zero),
          tl: /* [] */0
        }
      }
    });

function arg$1(param) {
  return BrowserStyle.withFont(param, /* Quicksand */0, /* Large */4, /* Bold */2);
}

var workerName = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined), {
          hd: BrowserStyle.mobileMedia(BrowserStyle.withFont(undefined, undefined, /* Small */2, undefined)(/* [] */0)),
          tl: /* [] */0
        }));

var Styles = {
  container: container,
  content: content,
  titleRow: titleRow,
  title: title,
  searchInput: searchInput,
  buttonContainer: buttonContainer,
  headerRow: headerRow,
  headerNameRow: headerNameRow,
  headerFlexPusher: headerFlexPusher,
  workerRow: workerRow,
  workerNameRow: workerNameRow,
  workerName: workerName
};

function getSearchedAndSortedWorkers(getWorkerName, searchTerm, sortOrder) {
  return Reselect.createSelector1(undefined, Relude_Globals.id, (function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great((function (param) {
                                            return Relude_Globals.$great$great(Relude_Map.valueArray, (function (param) {
                                                          return Relude_Array.keep((function (worker) {
                                                                        return Relude_Option.fold(true, (function (param) {
                                                                                      return Relude_Globals.$great$great(StringUtils.toLowerCase, (function (__x) {
                                                                                                    return Relude_String.contains(__x, StringUtils.toLowerCase(CommonTypes_User_Name.toString(Curry._1(getWorkerName, worker))));
                                                                                                  }), param);
                                                                                    }), Relude_String.toNonWhitespace(searchTerm));
                                                                      }), param);
                                                        }), param);
                                          }), (function (param) {
                                            return Relude_Array.sortBy((function (a, b) {
                                                          return Curry._2(CommonTypes_User_Name.compare, Curry._1(getWorkerName, a), Curry._1(getWorkerName, b));
                                                        }), param);
                                          }), param);
                            }), (function (sortedArray) {
                              if (sortOrder) {
                                return Relude_Array.reverse(sortedArray);
                              } else {
                                return sortedArray;
                              }
                            }), param);
              }));
}

function WebComponents_ToDoWorkerShiftList(Props) {
  var param = Props.actionButton;
  var children = Props.children;
  var headerChildren = Props.headerChildren;
  var getKebabMenuActions = Props.getKebabMenuActions;
  var getWorkerId = Props.getWorkerId;
  var getWorkerName = Props.getWorkerName;
  var getWorkerProfilePicture = Props.getWorkerProfilePicture;
  var responsiveLayout = Props.responsiveLayout;
  var title$1 = Props.title;
  var workers = Props.workers;
  var onClickActionButton = param.onClick;
  var match = ReactIO.useMappableState(function (param) {
        return /* Ascending */0;
      });
  var toggleSortOrder = Curry._1(match[1], CommonTypes.SortOrder.toggle);
  var match$1 = ReactIO.useState(function (param) {
        return "";
      });
  var setSearchTerm = match$1[1];
  var searchTerm = match$1[0];
  var getSearchedAndSortedWorkers$1 = ReactIO.useMemo4(getSearchedAndSortedWorkers, [
        getWorkerName,
        searchTerm,
        match[0],
        workers
      ]);
  return React.createElement(BrowserComponents_FlexColumn.make, {
              className: container,
              children: null
            }, responsiveLayout >= 2 ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_FlexRow.make, {
                        className: titleRow,
                        children: null
                      }, React.createElement(BrowserComponents_Text.make, {
                            className: title,
                            children: title$1
                          }), React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(undefined)(undefined, undefined, searchInput, undefined, undefined, undefined, {
                                    TAG: /* Navigation */5,
                                    _0: /* Search */15
                                  }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Search Professional's name", undefined, /* Small */1, undefined, undefined, undefined, undefined, undefined, undefined, undefined), {
                                TAG: /* Text */7,
                                _0: {
                                  onChange: setSearchTerm,
                                  value: searchTerm
                                }
                              }, undefined, undefined, undefined))), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* XLarge */6
                      })) : React.createElement(BrowserComponents_Input.make, Curry._4(BrowserComponents_Input.makeProps(undefined)(undefined, undefined, searchInput, undefined, undefined, undefined, {
                            TAG: /* Navigation */5,
                            _0: /* Search */15
                          }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Search Professional's name", undefined, /* Small */1, undefined, undefined, undefined, undefined, undefined, undefined, undefined), {
                        TAG: /* Text */7,
                        _0: {
                          onChange: setSearchTerm,
                          value: searchTerm
                        }
                      }, undefined, undefined, undefined)), React.createElement(BrowserComponents_FlexRow.make, {
                  className: headerRow(Relude_Option.isSome(getKebabMenuActions)),
                  children: null
                }, React.createElement(BrowserComponents_Button.Base.make, {
                      children: React.createElement(BrowserComponents_FlexRow.make, {
                            className: headerNameRow,
                            children: null
                          }, React.createElement(BrowserComponents_Text.make, {
                                children: "Professional Name"
                              }), React.createElement(BrowserComponents_Spacer.make, {
                                size: /* Small */3
                              }), React.createElement(BrowserComponents_FlexColumn.make, {
                                children: null
                              }, React.createElement(BrowserComponents_Icon.make, {
                                    color: {
                                      TAG: /* Grey */2,
                                      _0: /* Medium */2
                                    },
                                    icon: {
                                      TAG: /* Small */1,
                                      _0: {
                                        TAG: /* Arrow */0,
                                        _0: /* ChevronTop */14
                                      }
                                    },
                                    size: /* XSmall */0
                                  }), React.createElement(BrowserComponents_Icon.make, {
                                    color: {
                                      TAG: /* Grey */2,
                                      _0: /* Medium */2
                                    },
                                    icon: {
                                      TAG: /* Small */1,
                                      _0: {
                                        TAG: /* Arrow */0,
                                        _0: /* ChevronBottom */10
                                      }
                                    },
                                    size: /* XSmall */0
                                  }))),
                      onClick: (function (param) {
                          return toggleSortOrder;
                        })
                    }), React.createElement("div", {
                      className: headerFlexPusher
                    }), headerChildren), React.createElement(BrowserComponents_FlexColumn.make, {
                  className: content,
                  children: Curry._2(Relude_Array.map, (function (worker) {
                          return React.createElement(BrowserComponents_FlexRow.make, {
                                      className: workerRow,
                                      children: null,
                                      key: Curry._1(CommonTypes_Worker_Id.toString, Curry._1(getWorkerId, worker))
                                    }, React.createElement(BrowserComponents_FlexRow.make, {
                                          className: workerNameRow,
                                          children: null
                                        }, React.createElement(BrowserComponents_ProfilePicture.make, {
                                              profilePicture: Curry._1(getWorkerProfilePicture, worker)
                                            }), React.createElement(BrowserComponents_Spacer.make, {
                                              size: /* Small */3
                                            }), React.createElement(BrowserComponents_Text.make, {
                                              className: workerName,
                                              children: CommonTypes_User_Name.toString(Curry._1(getWorkerName, worker))
                                            }), React.createElement(BrowserComponents_Spacer.make, {
                                              size: /* Medium */4
                                            })), Curry._1(children, worker), Relude_Option.fold(null, (function (getActions) {
                                            return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                                                            size: /* XSmall */2
                                                          }), React.createElement(BrowserComponents_KebabMenu.make, {
                                                            actions: Curry._1(getActions, worker)
                                                          }));
                                          }), getKebabMenuActions));
                        }), getSearchedAndSortedWorkers$1)
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_FlexRow.make, {
                  className: buttonContainer,
                  children: React.createElement(BrowserComponents_Button.make, {
                        actionPriority: /* Primary */0,
                        disabled: param.disabled,
                        onClick: (function (param) {
                            return onClickActionButton;
                          }),
                        title: param.title
                      })
                }));
}

var make = WebComponents_ToDoWorkerShiftList;

exports.Styles = Styles;
exports.getSearchedAndSortedWorkers = getSearchedAndSortedWorkers;
exports.make = make;
/* container Not a pure module */
